import React from 'react';
import styled from '@emotion/styled';
import OfferDeclineIcon from '../icons/OfferDeclineIcon';
import OfferDollarIcon from '../icons/OfferDollarIcon';
import OfferAcceptIcon from '../icons/OfferAcceptIcon';
import { areEqual, isDarkMode } from '../../../../../utils/helpers';

const ButtonActionContainer = styled('div')({
  width: 64,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 8,
});

const ButtonLabelCounter = styled('span')({
  fontSize: 13,
  fontWeight: 400,
  letterSpacing: '-0.44px',
  lineHeight: '18px',
  color: isDarkMode() ? '#AFB0B1' : '#8F8F8F',
});

interface IProps {
  onClick: () => void;
  variant: 'decline' | 'accept' | 'offer' | 'request';
  btnRef?: React.RefObject<HTMLDivElement>;
}

const OneTapSwipeOfferActionButton: React.FC<IProps> = ({ onClick, variant, btnRef }: IProps) => {
  const renderIcon = () => {
    switch (variant) {
      case 'decline':
        return <OfferDeclineIcon />;
      case 'accept':
        return <OfferAcceptIcon />;
      case 'offer':
      case 'request':
        return <OfferDollarIcon />;
      default:
        return <></>;
    }
  };

  const renderLabel = () => {
    switch (variant) {
      case 'decline':
        return 'Decline';
      case 'accept':
        return 'Accept';
      case 'offer':
        return 'Offer';
      case 'request':
        return 'Request';
      default:
        return '';
    }
  };

  return (
    <ButtonActionContainer>
      <span style={{ borderRadius: 27, display: 'contents' }} onClick={onClick} ref={btnRef}>
        {renderIcon()}
      </span>
      <ButtonLabelCounter onClick={onClick} ref={btnRef}>
        {renderLabel()}
      </ButtonLabelCounter>
    </ButtonActionContainer>
  );
};

export default React.memo(OneTapSwipeOfferActionButton, areEqual);
